import { request } from "./medicalReviewApi";
import { toBackendTrialId } from "@/utils/trialIdMap";

/** Client for the participant profile-review ledger
 * (`/data/trial/<id>/subjects/<subject_id>/profile-review/`). */

export type ProfileReviewEntry = {
  id: number;
  action: "reviewed" | "review_reopened";
  comment: string;
  by: string;
  role: string;
  at: string;
};

export type ProfileReviewState = {
  subject_id: string;
  reviewed: boolean;
  last_reviewed: ProfileReviewEntry | null;
  history: ProfileReviewEntry[];
};

const url = (trialId: string, subjectId: string) =>
  `${import.meta.env.VITE_API_URL}/data/trial/${toBackendTrialId(trialId)}/subjects/${encodeURIComponent(subjectId)}/profile-review/`;

const profileReviewApi = {
  get: (trialId: string, subjectId: string): Promise<ProfileReviewState> =>
    request<ProfileReviewState>(url(trialId, subjectId)),

  mark: (
    trialId: string,
    subjectId: string,
    body: { action?: "reviewed" | "review_reopened"; comment?: string } = {},
  ): Promise<ProfileReviewState> =>
    request<ProfileReviewState>(url(trialId, subjectId), {
      method: "POST",
      body,
    }),
};

export default profileReviewApi;
